/**
 * AÏNN London - Cart Validation
 * Ensures add-on products can only be purchased with a main outfit
 *
 * Loaded via theme.liquid as an asset.
 *
 * Design notes for future-me:
 * - This file deliberately does NOT monkey-patch window.fetch or
 *   XMLHttpRequest. Doing so broke Heritage's native Add to Cart flow.
 * - Validation runs only on cart page and checkout page load.
 * - The real defence against the standalone add-on exploit is the
 *   "Buy X get Y" discount type configured in Shopify Discounts.
 *   This script is a secondary safety net for cart-page presence only.
 */

(function() {
  'use strict';

  // Add-on product handles - these cannot be purchased alone.
  // Update when new add-ons are introduced.
  const ADDON_HANDLES = [
    'matching-chiffon-hijab-add-on',
    'matching-potli-bag-add-on',
    'matching-pocket-square-add-on',
    'heavier-embroidery-dupatta-add-on'
  ];

  function isAddonProduct(item) {
    return ADDON_HANDLES.includes(item.handle);
  }

  function hasMainProduct(cartItems) {
    return cartItems.some(function(item) { return !isAddonProduct(item); });
  }

  async function removeFromCart(itemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });
      return await response.json();
    } catch (error) {
      console.error('[CART-VALIDATION] Error removing item:', error);
      return null;
    }
  }

  let isValidating = false;

  async function validateCart() {
    if (isValidating) return;
    isValidating = true;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (!cart.items || cart.items.length === 0) {
        return;
      }

      const hasMain = hasMainProduct(cart.items);

      if (!hasMain) {
        const addonsInCart = cart.items.filter(function(item) { return isAddonProduct(item); });

        if (addonsInCart.length > 0) {
          console.log('[CART-VALIDATION] No main product found, removing orphan add-ons');

          for (const addon of addonsInCart) {
            await removeFromCart(addon.key);
          }

          showNotification('Add-on items require a main outfit. They have been removed from your cart.');

          // Only reload if customer is actually on the cart or checkout page.
          // Don't reload product pages.
          const isCartPage = window.location.pathname.includes('/cart');
          const isCheckoutPage = window.location.pathname.includes('/checkout');
          if (isCartPage || isCheckoutPage) {
            setTimeout(function() { window.location.reload(); }, 1500);
          }
        }
      }
    } catch (error) {
      console.error('[CART-VALIDATION] Error validating cart:', error);
    } finally {
      isValidating = false;
    }
  }

  function showNotification(message) {
    if (typeof window.showToast === 'function') {
      window.showToast(message);
      return;
    }

    const notification = document.createElement('div');
    notification.style.cssText = [
      'position: fixed',
      'top: 20px',
      'left: 50%',
      'transform: translateX(-50%)',
      'background: #1a1a1a',
      'color: #fff',
      'padding: 16px 24px',
      'border-radius: 4px',
      'font-family: inherit',
      'font-size: 14px',
      'z-index: 99999',
      'max-width: 90%',
      'text-align: center',
      'box-shadow: 0 4px 20px rgba(0,0,0,0.3)'
    ].join(';');
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(function() { notification.remove(); }, 5000);
  }

  // Run on initial page load — catches cart and checkout pages.
  document.addEventListener('DOMContentLoaded', function() {
    const isCartPage = window.location.pathname.includes('/cart');
    const isCheckoutPage = window.location.pathname.includes('/checkout');
    if (isCartPage || isCheckoutPage) {
      validateCart();
    }
  });

})();